<template>
  <base-form
    v-slot="slotProps"
    :model="mapCollection"
    :rules="rules"
    :loading="loading"
    :form-submitted="formSubmitted"
    :submit-label="submitLabel"
    :mode="mode"
    model-name="Kartensammlung"
  >
    <el-form-item label="Name" prop="name">
      <el-input v-model="slotProps.model.name" v-focus></el-input>
    </el-form-item>

    <el-form-item label="Einrichtungssammlung">
      <el-cascader
        v-model="slotProps.model.institution_collection_id"
        :options="institutionCollectionsForCascader"
        :props="{
          multiple: false,
          checkStrictly: true,
          emitPath: false,
          expandTrigger: 'hover'
        }"
        placeholder="Einrichtungssammlung auswählen"
      ></el-cascader>
    </el-form-item>

    <el-form-item label="Farbe" prop="color">
      <el-color-picker v-model="slotProps.model.color"></el-color-picker>
    </el-form-item>

    <el-form-item label="Icon" prop="icon">
      <div class="icon-grid">
        <el-radio
          v-for="icon in mapIcons"
          :key="icon.id"
          v-model="slotProps.model.icon"
          :label="icon.id"
          border
          class="icon-radio"
        >
          <div class="icon-container">
            <svg
              class="icon-svg"
              :viewBox="getSvgViewBox(icon.svg)"
              width="36"
              height="36"
              v-html="processSvgContent(icon.svg, slotProps.model.color)"
            ></svg>
          </div>
        </el-radio>
      </div>
    </el-form-item>
  </base-form>
</template>

<script>
import GuideItemsRepository from "@/repositories/guide_items_repository.js"
import MapIconsRepository from "@/repositories/map_icons_repository.js"
import BaseForm from "@/components/forms/BaseForm"
import ApiErrorHandlerMixin from "@/mixins/api_error_handler.js"
import { defaultColorContrastValidator } from "@/utils/colorContrastValidator.js"
import { processSvgContent, getSvgViewBox } from "@/utils/svgHelpers.js"

export default {
  components: {
    BaseForm
  },
  mixins: [ApiErrorHandlerMixin],
  props: {
    mapCollection: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    submitLabel: {
      type: String,
      default: "Änderungen speichern"
    },
    formSubmitted: {
      type: Function,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loadingGuideItems: true,
      institutionCollections: [],
      mapIcons: [],
      rules: {
        color: [{ validator: defaultColorContrastValidator, trigger: "change" }]
      }
    }
  },
  computed: {
    institutionCollectionsForCascader() {
      return this.parseGuideItemTree(this.institutionCollections)
    }
  },
  created() {
    GuideItemsRepository.getAll()
      .then(collections => {
        this.institutionCollections = collections
        this.loadingGuideItems = false
      })
      .catch(error => {
        this.handleApiError(error, "Fehler Laden der Einrichtungssammlungen")
      })

    MapIconsRepository.getAll()
      .then(icons => {
        this.mapIcons = icons
      })
      .catch(error => {
        this.handleApiError(error, "Fehler beim Laden der Karten-Icons")
      })
  },
  methods: {
    parseGuideItemTree(collections) {
      let items = []
      let that = this
      collections.forEach(function(cat) {
        if (cat.type == "folder" || cat.type === "institutions") {
          let item = {
            label: cat.name,
            value: cat.collection_id,
            disabled: cat.type === "folder",
            children: that.parseGuideItemTree(cat.children)
          }
          items.push(item)
        }
      })
      return items
    },
    processSvgContent,
    getSvgViewBox
  }
}
</script>

<style scoped>
/* Grid for the marker icons */
.icon-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 12px;
  margin-top: 8px;
}

.icon-radio {
  margin: 0 !important;
  padding: 8px !important;
  width: 100% !important;
  height: auto !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.icon-radio .el-radio__label {
  padding-left: 0 !important;
}

.icon-container {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.icon-svg {
  display: block;
}
</style>
